export default __webpack_public_path__ + "static/ti_Monster_Green-f586ba318b320d056b5cdc65a2bf544b.png";